// extracted by mini-css-extract-plugin
module.exports = {"size":"styles_size__1vsq1","text":"styles_text__3iyo8","padding":"styles_padding__3lJpg"};